// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gilroySemiBold_b1e55d', '__gilroySemiBold_Fallback_b1e55d'","fontWeight":600},"className":"__className_b1e55d","variable":"__variable_b1e55d"};